import { FCC } from "@/types/common";
import { Typography, Stack, styled } from "@mui/material";
import { EMPTY_STR } from "@/constants/string";
import Divider from "@mui/material/Divider";
import { black, red, text } from "@/theme/colors";
import { convertNumberToZipCode, convertToPhoneNumber } from "@/utils/input";

type TCaseInfoItem = {
  label?: string;
  value?: string | null | undefined;
  direction?: "row" | "column";
  type?: string;
  color?: string;
  suffix?: string;
  required?: boolean;
  endIcon?: React.ReactNode;
  isShowDivider?: boolean;
};
export const CaseInfoItem: FCC<TCaseInfoItem> = ({
  label,
  value,
  direction,
  type = "string",
  color,
  suffix,
  endIcon,
  required = false,
  isShowDivider = true,
}) => {
  const getValue = () => {
    if (!value) return EMPTY_STR.TEXT;
    if (type === "zipcode") {
      return convertNumberToZipCode(value);
    }
    if (type === "phone") {
      return convertToPhoneNumber(value);
    }
    return value;
  };
  return (
    <>
      <CaseInfoItemWrapper direction={direction} gap={1}>
        {label && (
          <Typography variant="cap12Light" color={black[70]}>
            {label}
            {required && (
              <Typography component="span" variant="cap12" sx={{ color: red[700], ml: 0.5 }}>
                *
              </Typography>
            )}
          </Typography>
        )}
        <Stack direction="row" justifyContent="space-between" component={type === "textArea" ? "pre" : "div"} sx={{ fontFamily: "inherit" }}>
          <Typography variant="body14" color={color ? color : text.primary}>
            {getValue()}
            {suffix ?? ""}
          </Typography>
          <Stack>{endIcon}</Stack>
        </Stack>
        {isShowDivider && <DividerWrapper />}
      </CaseInfoItemWrapper>
    </>
  );
};

const CaseInfoItemWrapper = styled(Stack)<{ direction?: string }>`
  ${({ direction }) => (direction === "row" ? `align-items: center;` : ``)}
`;

const DividerWrapper = styled(Divider)`
  margin: 8px 0;
  width: 100%;
`;
